import React, { useEffect, useState } from 'react';
import SelectList from './visns-select-list';
import Select, { createFilter } from 'react-select';

function MultiSelect(props) {
    const { inputValue, onChange, options, settings, multi, placeholder } =
        props;
    const [selectOptions, setSelectOptions] = useState([]);

    useEffect(() => {
        let _options = [];

        options.forEach((a) => {
            _options.push({
                value: a.id,
                label: a.label,
            });
        });

        setSelectOptions(_options);
    }, [options]);

    return (
        <Select
            isClearable
            isSearchable
            isMulti={multi}
            filterOption={createFilter({ ignoreAccents: false })}
            components={{ SelectList }}
            options={selectOptions}
            onChange={(inputValue, action) => {
                onChange(inputValue, action, settings.id);
            }}
            placeholder={placeholder === '' ? 'Select...' : placeholder}
            className="visns__ms"
            styles={{
                menu: (provided) => ({ ...provided, zIndex: 9999 }),
                control: (base) => ({
                    ...base,
                    minHeight: '52px',
                }),
            }}
            value={inputValue}
        />
    );
}

export default MultiSelect;
